import * as React from "react";
import * as Utility from "./Utility";
/**
 * 時間の時コンボボックスのオプション配列を生成します。
 *
 * @param time 時間
 */

export function CreateHoursOptions() {
  var result = [];

  for (var i = 0; i <= 23; i++) {
    result.push( /*#__PURE__*/React.createElement("option", {
      value: i,
      key: i
    }, Utility.ZeroPadding(i, 2)));
  }

  return result;
}
/**
 * 時間の分コンボボックスのオプション配列を生成します。
 *
 * @param time 時間
 */

export function CreateMinutesOptions() {
  var result = [];

  for (var i = 0; i <= 59; i++) {
    result.push( /*#__PURE__*/React.createElement("option", {
      value: i,
      key: i
    }, Utility.ZeroPadding(i, 2)));
  }

  return result;
}
/**
 * 時間の分コンボボックスのオプション配列を生成します。
 *
 * @param time 時間
 */

export function CreateUnitsOf15MinutesOptions() {
  var result = [];
  var values = [0, 15, 30, 45];

  for (var i = 0; i < values.length; i++) {
    result.push( /*#__PURE__*/React.createElement("option", {
      value: values[i],
      key: values[i]
    }, Utility.ZeroPadding(values[i], 2)));
  }

  return result;
}
/**
 * Hoursドロップダウン用のリストアイテムを生成します。
 */

export function CreateHoursListItems(f) {
  var result = [];

  for (var i = 0; i < 24; i++) {
    result.push( /*#__PURE__*/React.createElement("li", {
      value: i,
      onClick: f
    }, Utility.ZeroPadding(i, 2)));
  }

  return result;
}
/**
 * Minutesドロップダウン用のリストアイテムを生成します。
 */

export function CreateUnitsOf15MinutesListItems(f) {
  var result = [];
  var values = [0, 15, 30, 45];

  for (var i = 0; i < values.length; i++) {
    result.push( /*#__PURE__*/React.createElement("li", {
      value: values[i],
      onClick: f
    }, Utility.ZeroPadding(values[i], 2)));
  }

  return result;
}